
const miRootState = {
    parent: 'root',
    url: '/mireports',
    abstract: true,
    template: '<ui-view></ui-view>'
};

const miDetailsState = {
    url: '/:reportName',
    controllerAs: 'miReportDetails',
    template: require('./controllers/reportGeneration/miReportDetails.html'),
    controller: require('./controllers/reportGeneration/miReportDetailsCtrl')
};

export default function (app) {
    app.config(($stateProvider, userRolesObject) => {
        miRootState.data = {
            roles: [userRolesObject.admin, userRolesObject.teamLead]
        };

        $stateProvider
            .state('mireports', miRootState)
            .state('mireports.details', miDetailsState);
    });
}



// WEBPACK FOOTER //
// ./Client/app/mireports/routes.js